<template>
	<v-main>
		<div v-if="haveAccess">
			<div class="main-large">
				<v-toolbar color="#2C2C2C" solo flat dense>
					<v-row justify="space-between" align="center">
						<v-col cols="4" sm="2">
							<v-btn
								@click="navigate('prev')"
								style="text-transform: none; padding-left: 0"
								color="#2C2C2C"
								dark
								depressed
								:disabled="pageChange"
							>
								<v-icon>mdi-chevron-left</v-icon>Previous
							</v-btn>
						</v-col>
						<v-col cols="4" sm="5">
							<v-autocomplete
								v-model="selectedId"
								:loading="loading"
								:items="items"
								:search-input.sync="search"
								flat
								hide-no-data
								hide-details
								item-text="name"
								label="Search Booths"
								item-value="id"
								@change="showSelectedBooth"
								solo
								dark
								dense
								append-icon
								prepend-inner-icon="mdi-magnify"
								style="margin-bottom: 10px"
							></v-autocomplete>
						</v-col>
						<v-btn @click="navigate('next')" style="text-transform: none" color="#2C2C2C" dark depressed :disabled="pageChange">
							Next
							<v-icon>mdi-chevron-right</v-icon>
						</v-btn>
					</v-row>
				</v-toolbar>
			</div>

			<div id="structure-view">
				<div class="entry-view" id="main-display">
					<div
						style="display: inline-block; position: relative; min-width: 100%; overflow: hidden"
						:style="{
							backgroundImage: 'url(' + $root.asset(entity.boothBackgroundImage) + ')',
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							backgroundRepeat: 'no-repeat',
							maxHeight: $vuetify.breakpoint.smAndDown ? '100vmax !important;' : 'calc(100vmax * (9/16)) !important;'
						}"
						ref="background"
					>
						<div class="back-to-floor">
							<v-btn class="hidden-sm-and-down" @click="navigateStructure" color="white" rounded small style="text-transform: none">
								<v-icon>mdi-arrow-left</v-icon>Back to Floor
							</v-btn>
							<v-btn v-if="widthMenu != 0" class="hidden-md-and-up" @click="navigateStructure" color="white" rounded small
								style="text-transform: none; position: fixed;"
								:style="{top: topPosBtnBackToFloor + 'px'}"
							>
								<v-icon>mdi-arrow-left</v-icon>Back to Floor
							</v-btn>
						</div>
						<div style="display: inline-block; position: relative; min-width: 100%; overflow-x: auto" class="booth-img">
							<img
								style="width: auto; min-width:100%;right: 0, bottom:0;"
								:style="$vuetify.breakpoint.smAndDown ? 'height: 100vmax;' : 'height: calc(100vmax * (9/16));'"
								title
								:src="$root.asset(boothImage)"
							/>
							<div v-if="entity.bannerList">
								<div v-for="(banner, idxBanner) in entity.bannerList" :key="idxBanner">
									<div v-if="banner.coordinateList" class="banner-place">
										<video
											v-if="banner.image && banner.image.endsWith('.mp4')"
											id="video"
											:style="{
												zIndex: 1,
												left: banner.coordinateList[0] + '%',
												top: banner.coordinateList[1] + '%',
												transform: banner.skewX
													? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
													: 'skew(0deg, 0deg)',
												width: banner.coordinateList[2] + '%',
												height: banner.coordinateList[3] + '%',
												position: 'absolute'
											}"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="$root.asset(banner.image)" type="video/mp4" />
										</video>
										<img
											v-if="banner.image && !banner.image.endsWith('.mp4')"
											:style="{
												zIndex: 1,
												left: banner.coordinateList[0] + '%',
												top: banner.coordinateList[1] + '%',
												transform: banner.skewX
													? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
													: 'skew(0deg, 0deg)',
												width: banner.coordinateList[2] + '%',
												height: banner.coordinateList[3] + '%',
												position: 'absolute',
												objectFit: banner.bannerImageType,
												backgroundColor: 'white'
											}"
											title
											:src="$root.asset(banner.image)"
										/>
										<a
											v-if="banner.url && banner.openLinkOption == '1'"
											:style="{
												zIndex: 2,
												left: banner.coordinateList[0] + '%',
												top: banner.coordinateList[1] + '%',
												transform: banner.skewX
													? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
													: 'skew(0deg, 0deg)',
												width: banner.coordinateList[2] + '%',
												height: banner.coordinateList[3] + '%',
												position: 'absolute'
											}"
											:href="banner.url.startsWith('http') ? banner.url : $root.asset(banner.url)"
											target="_blank"
											@click="visitBoothBanner(banner)"
										></a>
										<a
											v-if="banner.url && banner.openLinkOption == '2'"
											:style="{
												zIndex: 2,
												left: banner.coordinateList[0] + '%',
												top: banner.coordinateList[1] + '%',
												transform: banner.skewX
													? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
													: 'skew(0deg, 0deg)',
												width: banner.coordinateList[2] + '%',
												height: banner.coordinateList[3] + '%',
												position: 'absolute'
											}"
											@click="showBanner(banner)"
											style="text-decoration: none"
										></a>
										<a
											v-if="banner.url && banner.openLinkOption == '3'"
											:style="{
												zIndex: 2,
												left: banner.coordinateList[0] + '%',
												top: banner.coordinateList[1] + '%',
												transform: banner.skewX
													? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
													: 'skew(0deg, 0deg)',
												width: banner.coordinateList[2] + '%',
												height: banner.coordinateList[3] + '%',
												position: 'absolute'
											}"
											:href="banner.url.startsWith('http') ? banner.url : $root.asset(banner.url)"
											@click="visitBoothBanner(banner)"
										></a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="showBannerPopup">
				<v-dialog v-model="showBannerPopup" content-class="v-dialog--custom" persistent>
					<v-card height="90vh">
						<v-card-title>
							<span class="headline"></span>
							<v-spacer></v-spacer>
							<v-icon
								@click="
									showBannerPopup = false;
									iframeBanner = false;
								"
								>mdi-close</v-icon
							>
						</v-card-title>
						<iframe
							v-if="iframeBanner"
							frameborder="0"
							allow="autoplay; encrypted-media"
							scrolling="0"
							width="100%"
							class="iframe-size"
							:src="$root.asset(entity.bannerList[currentIndex].url)"
							allowfullscreen
							style="height:93%"
						></iframe>
					</v-card>
				</v-dialog>
			</div>

			<div class="main-large d-flex flex-column" :style="{backgroundColor: color.bottomBackgroundColor}">
				<v-row class="mx-0">
					<v-col cols="12" class="pa-0">
						<v-card tile width="100%" :color="color.backgroundColor" elevation="0" class="card-height" flat v-if="entity.boothFeatureList.length > 0">
							<v-card-title>
								<h2 class="booth-name">{{ entity.name }}</h2>
							</v-card-title>
							<div style="margin-left: 40px; margin-right: 20px">
								<div class="box hidden-sm-and-down">
									<div class="first-item">
										<ul id="detail-nav" style="margin-top: 10px" :style="styleObject">
											<li v-for="(tab, idxtab) in entity.boothFeatureList" :key="idxtab">
												<a @click="setActive(tab)" v-if="tab.status">
													<v-icon color="white" small>{{ tab.icon }}</v-icon>
													&nbsp;{{ tab.tabTitle }}
												</a>
												<hr
													v-bind:class="{
														active: active === tab.tabTitle
													}"
													v-if="active == tab.tabTitle && tab.status"
												/>
												<hr class="title-line" v-if="active != tab.tabTitle && tab.status" />
											</li>
										</ul>
									</div>
									<div class="second-item">
										<h2 style="color: white; margin-top: 58px"></h2>
										<hr class="title-line" />
									</div>
								</div>

								<div class="hidden-md-and-up">
									<v-card :color="color.backgroundColor" flat style="margin-right: 20px">
										<v-card-title :color="color.backgroundColor">
											<v-toolbar-title style="color: white">
												<v-icon style="color: white; margin-right: 20px">{{ iconActive }}</v-icon>
												{{ active }}
											</v-toolbar-title>

											<v-spacer></v-spacer>

											<v-menu bottom left absolute :color="color.backgroundColor" max-width="300">
												<template v-slot:activator="{ on, attrs }">
													<v-btn dark icon v-bind="attrs" v-on="on">
														<v-icon>mdi-menu</v-icon>
													</v-btn>
												</template>

												<v-list :color="color.backgroundColor" outlined width="300px" height="100%">
													<v-template v-for="(item, i) in entity.boothFeatureList" :key="i">
														<v-list-item @click="setActive(item)" v-if="item.status">
															<v-list-item-icon>
																<v-icon style="color: white" v-text="item.icon"></v-icon>
															</v-list-item-icon>
															<v-list-item-title style="color: white">
																{{ item.tabTitle }}
																<hr class="title-line" />
															</v-list-item-title>
														</v-list-item>
													</v-template>
												</v-list>
											</v-menu>
										</v-card-title>
										<hr style="border: 1.5px solid white; background-color: white" />
									</v-card>
								</div>

								<v-card :color="color.backgroundColor" dark height="400" elevation="0" class="scroll content-card">
									<span v-if="active == entity.boothFeatureList[0].tabTitle">
										<div style="margin-top: 20px; color: black" v-html="entity.description"></div>
									</span>
									<span v-if="active == entity.boothFeatureList[2].tabTitle">
										<ul v-for="(video, idxVideo) in videos" :key="idxVideo" id="feature" :style="{backgroundColor: color.backgroundColor}">
											<li style="display: flex; flex-direction: row; justify-content: space-between">
												<div style="display: flex; flex-direction: row; justify-content: space-between">
													<span>
														<v-icon small>mdi-play-circle-outline</v-icon>
														{{ video.title }}
													</span>
												</div>
												<v-btn
													v-if="video.dataMap.openLinkOption && video.dataMap.openLinkOption == '1'"
													:color="color.buttonBackgroundColor2"
													rounded
													small
													width="15"
													@click="watchVideo(video.id)"
												>
													<a
														target="_blank"
														:style="{
															backgroundColor: 'transparent',
															textTransform: 'none',
															textDecoration: 'none',
															color: color.buttonFontColor2}"
														:href="$root.asset(video.value)"
														>View</a
													>
												</v-btn>
												<v-btn
													v-else
													@click="openDocuments(video, 'video')"
													:style="{
														backgroundColor: color.buttonBackgroundColor2,
														color: color.buttonFontColor2
													}"
													rounded
													small
													width="15"
													style="text-transform: none"
													>View</v-btn
												>
											</li>
											<hr class="horizontal-line" />
										</ul>
									</span>

									<span v-if="active == entity.boothFeatureList[1].tabTitle">
										<ul v-for="(doc, idxDoc) in documents" :key="idxDoc" id="feature" :style="{backgroundColor: color.backgroundColor}">
											<li style="display: flex; flex-direction: row; justify-content: space-between">
												<div style="display: flex; flex-direction: row; justify-content: space-between">
													<span>
														<v-icon small>mdi-file-pdf</v-icon>
														{{ doc.title }}
													</span>
												</div>
												<div style="display: flex; flex-direction: row; justify-content: space-between">
													<v-btn
														class="hidden-sm-and-down"
														@click="addBriefcase(doc)"
														rounded
														style="text-transform: none; color: white; margin-right: 10px"
														:color="color.backgroundColor"
														outlined
														height="100%"
														>Save to My Documents</v-btn
													>
													<v-icon class="hidden-md-and-up" @click="addBriefcase(doc)" style="margin-right: 20px"
														>mdi-content-save</v-icon
													>
													<v-btn
														v-if="doc.dataMap.openLinkOption && doc.dataMap.openLinkOption == '1'"
														:color="color.buttonBackgroundColor2"
														rounded
														small
														width="15"
														@click="viewDocument(doc.id)"
													>
														<a
															target="_blank"
															:style="{
																backgroundColor: 'transparent',
																textTransform: 'none',
																textDecoration: 'none',
																color: color.buttonFontColor2}"
															:href="$root.asset(doc.value)"
															>View</a
														>
													</v-btn>
													<v-btn
														v-else
														@click="openDocuments(doc, 'document')"
														:style="{
															backgroundColor: color.buttonBackgroundColor2,
															color: color.buttonFontColor2
														}"
														rounded
														small
														width="15"
														style="text-transform: none"
														>View</v-btn
													>
												</div>
											</li>
											<hr class="horizontal-line" />
										</ul>
									</span>

									<span v-if="active == entity.boothFeatureList[3].tabTitle">
										<ul id="feature" v-for="(menuLink, idxMenuLink) in entity.menuLinkList" :key="idxMenuLink" :style="{backgroundColor: color.backgroundColor}">
											<li style="display: flex; flex-direction: row; justify-content: space-between">
												<a
													v-if="menuLink.openLinkOption == 1 && menuLink.status"
													:href="menuLink.url"
													target="_blank"
													style="text-decoration: none"
													@click="visitLink(menuLink)"
													>{{ menuLink.title }}</a
												>
												<a
													v-if="menuLink.openLinkOption == 2 && menuLink.status"
													:href="menuLink.url"
													@click="visitLink(menuLink)"
													style="text-decoration: none"
													>{{ menuLink.title }}</a
												>
											</li>
											<hr class="horizontal-line" v-if="menuLink.status" />
										</ul>
									</span>
									<span v-if="active == entity.boothFeatureList[4].tabTitle">
										<ul id="feature" v-for="(boothRep, idxBoothRep) in boothRepList" :key="idxBoothRep" :style="{backgroundColor: color.backgroundColor}">
											<li>
												{{ boothRep.firstName }}
												{{ boothRep.lastName }}
												{{ boothRep.dataMap.availability == "" || !boothRep.dataMap.availability ? "" : "-" }}
												{{ boothRep.dataMap.availability }}
											</li>
										</ul>
									</span>
									<span v-if="active == entity.boothFeatureList[5].tabTitle">
										<v-text-field
											v-model="searchParam"
											@keyup="searchProduct"
											class="mx-4"
											label="Search Products by name or item number"
											append-icon="mdi-close-circle-outline"
											prepend-inner-icon="mdi-magnify"
											full-width
											@click:append="clearSearch"
											solo
											flat
											dense
										></v-text-field>
										<v-simple-table class="hidden-sm-and-down" :style="{backgroundColor: color.backgroundColor}">
											<template v-slot:default>
												<thead>
													<tr>
														<th class="text-left">SKU #</th>
														<th class="text-left">Title</th>
														<th class="text-left">Product Category</th>
														<th class="text-left">Price</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(item, idxItem) in productList" :key="idxItem">
														<td>{{ item.sku }}</td>
														<td>{{ item.title }}</td>
														<td>{{ item.productCategory }}</td>
														<td>${{ item.price }}</td>
													</tr>
												</tbody>
											</template>
										</v-simple-table>
										<ul class="hidden-md-and-up">
											<li v-for="(item, idxItem) in productList" :key="idxItem">
												<span style="display: flex; flex-direction: row; justify-content: space-between">
													<p>{{ item.sku }}</p>
													<p>{{ item.productCategory }}</p>
													<p>${{ item.price }}</p>
												</span>
												<p>{{ item.title }}</p>
												<hr class="title-class" />
											</li>
										</ul>
									</span>
									<span v-if="active == 'Booth Stats'">
										<v-container fluid :color="color.backgroundColor">
											<v-row>
												<v-col cols="12">
													<v-row align="start" justify="center" style="height: 300px">
														<v-card :color="color.backgroundColor" outlined tile>
															<v-responsive
																class="text-center black lighten-2 rounded-circle d-inline-flex align-center justify-center ma-3"
																height="70"
																width="70"
																style="color: orange; font-size: 24px; font-weight: bold"
																>{{ totalBoothVisitor }}</v-responsive
															>
															<p style="color: white">Total Visitors</p>
														</v-card>
													</v-row>
												</v-col>
											</v-row>
										</v-container>
									</span>
								</v-card>
							</div>
						</v-card>
					</v-col>
				</v-row>

				<!-- Chat Box START -->

				<template  v-if="entity.transitMap.isUseCometChat">
					<v-container v-if="!noChatBooth" class="pb-0">
						<v-row v-if="!noChatBooth" no-gutters class="d-flex justify-end align-end pb-0">
							<v-col :cols="!isMobile ? 9 : 3"> </v-col>
							<v-col :cols="!isMobile ? 2 : 5" class="d-flex justify-end">
								<v-card-text class="font-weight-bold" style="text-align: right"> Chat Notification Sound </v-card-text>
							</v-col>
							<v-col :cols="!isMobile ? 1 : 4" class="d-flex justify-end">
								<v-switch @change="soundSwitch()" v-model="chatBox.chatNotificationSound" inset :label="chatBox.chatNotificationSound ? 'Active' : 'Inactive'" dense></v-switch>
							</v-col>
						</v-row>
					</v-container>

					<v-row v-if="!noChatBooth">
						<v-col cols="12" style="margin-bottom: 80px">
							<v-container id="chatCard">
								<v-row no-gutters>
									<v-col :cols="!isMobile ? 3 : 12" class="pa-0" v-if="!isMobile || (isMobile && showMobileConversation)">
										<v-card class="scrollable" height="100%">
											<v-tabs
												v-model="chatTab"
												background-color="#4e7c83"
												dark
												show-arrows
												fixed-tabs
												v-if="isMobile && showMobileConversation"
											>
												<v-tab
													v-model="chatTab"
													v-for="(category, idxCategory) in chatCategories"
													:key="idxCategory"
													@click="goToSelectedTab(category.content)"
												>
													<v-badge :value="category.isBadgeOn" dot color="red">{{ category.tab }}</v-badge>
												</v-tab>
											</v-tabs>

											<v-card v-if="!isMobile">
												<center>
													<h4 style="margin-bottom: 3px">Conversations</h4>
												</center>
											</v-card>

											<table style="border-collapse: separate; border-spacing: 0.5em">
												<tr v-for="(conversation, i) in chatBox.conversationList" :key="i">
													<template v-if="conversation.type == 'group'">
														<td>
															<v-avatar>
																<v-icon size="45" color="black">mdi-account-multiple</v-icon>
															</v-avatar>
														</td>
														<div style="position: relative">
															<td
																class="ellipsis"
																@click="converse('group', conversation.id, conversation.name)"
																style="cursor: pointer"
															>
																{{ conversation.name }}
																<br />
																<span style="font-size: 12px; color: #bdbdbd">
																	{{ conversation.lastMessage && content(conversation.lastMessage) }}
																</span>
															</td>
														</div>
														<td>
															<v-avatar size="25" color="red" v-if="conversation.unreadCount">
																<span style="color: white; font-size: 12px">{{ conversation.unreadCount }}</span>
															</v-avatar>
														</td>
													</template>
													<template v-else-if="conversation.type == 'user'">
														<td>
															<v-avatar>
																<img :src="$root.avatar(conversation.id)" />
															</v-avatar>
														</td>
														<div style="position: relative">
															<td
																class="ellipsis"
																@click="converse('user', conversation.id, conversation.name)"
																style="cursor: pointer"
															>
																{{ conversation.name }}
																<br />
																<span style="font-size: 12px; color: #bdbdbd">
																	{{ conversation.lastMessage && content(conversation.lastMessage) }}
																</span>
															</td>
														</div>
														<td>
															<v-avatar size="25" color="red" v-if="conversation.unreadCount">
																<span style="color: white; font-size: 12px">{{ conversation.unreadCount }}</span>
															</v-avatar>
														</td>
													</template>
												</tr>
											</table>
										</v-card>
									</v-col>
									<v-col :cols="!isMobile ? 6 : 12" class="pa-0" v-if="!isMobile || (isMobile && showMobileChat)">
										<v-card>
											<v-tabs
												v-model="chatTab"
												background-color="#4e7c83"
												dark
												show-arrows
												fixed-tabs
												v-if="isMobile && showMobileChat"
											>
												<v-tab
													v-model="chatTab"
													v-for="(category, idxCategory) in chatCategories"
													:key="idxCategory"
													@click="goToSelectedTab(category.content)"
												>
													<v-badge :value="category.isBadgeOn" dot color="red">{{ category.tab }}</v-badge>
												</v-tab>
											</v-tabs>

											<v-card-text style="border-bottom: 1px solid #eee">
												<center>
													<h4 style="margin-bottom: 3px">{{ this.chatBox.conversation.name }}</h4>
												</center>
												<div class="scrollable" id="chatBox">
													<v-progress-linear
														rounded
														v-show="chatBox.loading"
														:indeterminate="chatBox.loading"
													></v-progress-linear>

													<center>
														<a v-if="!chatBox.noMore" @click="listMessageHistory">Load previous messages</a>
													</center>

													<div v-for="(message, idxMessage) in chatBox.messageList" :key="idxMessage">
														<!-- incoming -->
														<div v-if="message.sender.uid != chatBox.chatUser.uid && message.category == 'message'">
															<table>
																<tr>
																	<td style="vertical-align: top">
																		<v-avatar>
																			<img :src="$root.avatar(message.sender.uid)" />
																		</v-avatar>
																	</td>
																	<td>
																		<v-card class="pa-2">
																			<span style="font-weight: bold">{{ message.sender.name }}</span>
																			<br />
																			<span
																				:style="{
																					color: message.category == 'message' ? 'rgba(0,0,0,0.95)' : '#a5a5a5'
																				}"
																				>{{ content(message) }}</span
																			>
																		</v-card>
																		<div style="color: #646464; font-size: 12px">
																			{{ formatDate(message.sentAt) }}
																		</div>
																	</td>
																</tr>
															</table>
														</div>

														<!-- outgoing -->
														<div v-else-if="message.category == 'message'" style="display: flex; justify-content: flex-end">
															<table>
																<tr>
																	<td>
																		<v-card class="pa-2" color="#5f949c">
																			<span
																				:style="{
																					color: message.category == 'message' ? 'rgba(0,0,0,0.95)' : '#a5a5a5'
																				}"
																				>{{ content(message) }}</span
																			>
																		</v-card>
																		<div style="color: #646464; font-size: 12px">
																			{{ formatDate(message.sentAt) }}
																		</div>
																	</td>
																	<td style="vertical-align: top">
																		<v-avatar>
																			<img :src="$root.avatar(message.sender.uid)" />
																		</v-avatar>
																	</td>
																</tr>
															</table>
														</div>
													</div>
												</div>
											</v-card-text>

											<v-form ref="messageForm" v-model="chatBox.validMessage">
												<div style="display: flex; align-items: center">
													<v-textarea
														v-model="chatBox.chatMessage"
														:rules="chatBox.chatMessageRules"
														placeholder="Type your message here"
														flat
														solo
														dense
														hide-details
														no-resize
														rows="3"
														style="font-size: 13px"
														:disabled="pageChange"
													></v-textarea>
													<v-btn fab x-small color="primary" class="mx-5" @click="sendMessage" :disabled="pageChange">
														<v-icon>mdi-send</v-icon>
													</v-btn>
												</div>
											</v-form>
										</v-card>
									</v-col>

									<v-col :cols="!isMobile ? 3 : 12" class="pa-0" v-if="!isMobile || (isMobile && showMobileUserOnline)">
										<v-tabs
											v-model="chatTab"
											background-color="#4e7c83"
											dark
											show-arrows
											fixed-tabs
											v-if="isMobile && showMobileUserOnline"
										>
											<v-tab
												v-model="chatTab"
												v-for="(category, idxCategory) in chatCategories"
												:key="idxCategory"
												@click="goToSelectedTab(category.content)"
											>
												<v-badge :value="category.isBadgeOn" dot color="red">{{ category.tab }}</v-badge>
											</v-tab>
										</v-tabs>

										<v-card class="scrollable" height="100%">
											<v-card v-if="!isMobile">
												<center>
													<h4 style="margin-bottom: 3px">
														Users Online
														<v-menu top offset-y>
															<template v-slot:activator="{ on, attrs }">
																<v-btn icon v-bind="attrs" v-on="on">
																	<v-icon>mdi-information-outline</v-icon>
																</v-btn>
															</template>

															<v-list dense>
																<v-list-item>
																	<v-list-item-title
																		>You don't see yourself as online in the list below.</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</h4>
												</center>
											</v-card>

											<table>
												<tr v-for="(visitor, i) in chatBox.visitorList" :key="i">
													<td>
														<v-avatar>
															<img :src="$root.avatar(visitor.uid)" />
														</v-avatar>
													</td>
													<td @click="converse('user', visitor.uid, visitor.name)" style="cursor: pointer">
														{{ visitor.name }}
													</td>
													<td>
														<v-btn icon small @click="converse('user', visitor.uid, visitor.name)">
															<v-icon>mdi-message</v-icon>
														</v-btn>
													</td>
													<td>
														<v-menu offset-y class="mx-2">
															<template v-slot:activator="{ on, attrs }">
																<v-btn icon small v-bind="attrs" v-on="on">
																	<v-icon>mdi-phone</v-icon>
																</v-btn>
															</template>
															<v-list flat elevation="0">
																<v-list-item @click="callUser(visitor.uid, 'video', 'user')">
																	<v-list-item-icon class="mr-4">
																		<v-icon>mdi-video</v-icon>
																	</v-list-item-icon>

																	<v-list-item-content>
																		<v-list-item-title>Video Call</v-list-item-title>
																	</v-list-item-content>
																</v-list-item>
																<v-list-item @click="callUser(visitor.uid, 'audio', 'user')">
																	<v-list-item-icon class="mr-4">
																		<v-icon>mdi-microphone</v-icon>
																	</v-list-item-icon>

																	<v-list-item-content>
																		<v-list-item-title>Audio Call</v-list-item-title>
																	</v-list-item-content>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</table>
										</v-card>
									</v-col>

									<!-- incoming call dialog -->
									<v-dialog v-model="call.incomingCall" persistent no-click-animation max-width="300">
										<v-card rounded="xl" dark elevation="0">
											<v-card-text class="d-flex flex-column align-center pa-4">
												Incoming call
												<br />
												<span class="font-weight-bold body-1" style="text-align: center">
													{{ call.caller && call.caller.name ? call.caller.name : "" }}
												</span>
											</v-card-text>
											<v-card-actions class="pt-2 pb-4 px-8">
												<v-btn class="mx-2" fab dark color="green" @click="acceptCall()">
													<v-icon dark>mdi-phone</v-icon>
												</v-btn>
												<v-spacer></v-spacer>
												<v-btn class="mx-2" fab dark color="red" @click="rejectCall('reject')">
													<v-icon dark>mdi-phone-hangup</v-icon>
												</v-btn>
											</v-card-actions>
										</v-card>
									</v-dialog>

									<!-- ongoing call dialog -->
									<v-dialog v-model="call.ongoingCall" persistent no-click-animation max-width="500">
										<v-card dark elevation="0">
											<div id="callScreen"></div>
										</v-card>
									</v-dialog>

									<!-- call on progress dialog -->
									<v-dialog v-model="call.callingProgress" persistent no-click-animation max-width="300">
										<v-card rounded="xl" dark elevation="0">
											<v-card-text class="d-flex flex-column align-center pa-4">
												Calling...
												<br />
												<span class="font-weight-bold body-1" style="text-align: center">
													{{ call.receiver && call.receiver.name ? call.receiver.name : "" }}
												</span>
											</v-card-text>
											<v-card-actions class="pt-2 pb-4 px-8 d-flex flex-column align-center">
												<v-btn class="mx-2" fab dark color="red" @click="rejectCall('cancel')">
													<v-icon dark>mdi-phone-hangup</v-icon>
												</v-btn>
											</v-card-actions>
										</v-card>
									</v-dialog>
								</v-row>
							</v-container>
						</v-col>
					</v-row>
				</template>
				<v-row v-else >
					<v-col cols="12" class="ml-4" style="margin-bottom: 80px">
						<iframe
							id="chatCard"
							:src="$vchaturl + '/frontend/?e=' + $store.state.principal.chatEventToken +
								'&r=' + entity.dataMap.ChatRoomToken +
								'&u=' + $store.state.principal.chatUserToken +
								'&o=&i=&sr=0&sm=1&seu=0&sru=1'"
							style="height:725px; width: 98%"
							allow="camera; microphone;"
						></iframe>
					</v-col>
				</v-row>
			</div>

			<!-- Chat Box END -->

			<v-dialog v-model="showDocument" content-class="v-dialog--custom" persistent>
				<v-card v-if="selectedDocument != null" style="height:90vh">
					<v-card-title>
						<span class="headline">{{ selectedDocument.title }}</span>
						<v-spacer></v-spacer>
						<v-icon @click="closeDoc">mdi-close</v-icon>
					</v-card-title>
					<iframe
						v-if="iframeDoc"
						frameborder="0"
						allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
						scrolling="0"
						width="100%"
						class="iframe-size"
						:src="$root.asset(selectedDocument.value)"
						allowfullscreen
						style="height:92%"
					></iframe>
				</v-card>
			</v-dialog>

			<v-snackbar v-model="snackbar">
				{{ snackbarContent }}
				<template v-slot:action="{ attrs }">
					<v-btn color="red" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
				</template>
			</v-snackbar>

			<v-fab-transition>
				<v-btn
					style="z-index:3"
					v-if="!noChatBooth && goToChat"
					class="ma-4 mb-15 pa-2"
					:color="color.buttonBackgroundColor"
					:style="{color:color.buttonFontColor}"
					dark
					fixed
					bottom
					right
					@click="scrollToChat()"
					width="auto"
					:height="isMobile ? '80px' : 'auto'"
				>
					<img :class="isMobile ? 'imgMobile' : ''" src="./../../assets/Chatbox/gif-bounce-arrow-down.gif" />
					<span v-if="!isMobile" class="pl-4">Go to chat</span>
					<span v-else class="spanMobile"> <br />Chat </span>
				</v-btn>
				<v-btn
					v-else-if="!noChatBooth"
					class="ma-4 mb-15 pa-2"
					:color="color.buttonBackgroundColor"
					:style="{color:color.buttonFontColor}"
					dark
					fixed
					bottom
					right
					@click="scrollToTopPage()"
					width="auto"
					:height="isMobile ? '80px' : 'auto'"
				>
					<img :class="isMobile ? 'imgMobile' : ''" src="./../../assets/Chatbox/gif-bounce-arrow-up.gif" />
					<span v-if="!isMobile" class="pl-4">Back to top</span>
					<span v-else class="spanMobile"> <br />Top </span>
				</v-btn>
			</v-fab-transition>
		</div>

		<v-row v-if="$store.state.isPoweredBy" style="background-color: black">
			<v-col cols="12" sm="12">
				<div id="v-footer" style="height: 50px; background-color: black" v-if="$store.state.footerText === ''">
                    <p class="text-center" style="color: #cccccc;padding-top: 15px">Powered by <a href="https://v-unite.com/" target="_blank" style="color:#cccccc">V-Unite</a></p>
                </div>
                <div id="v-footer" style="height: 50px; background-color: black" v-else>
                    <p class="text-center" style="color: #cccccc;padding-top: 15px">{{ $store.state.footerText }}</p>
                </div>
			</v-col>
		</v-row>
	</v-main>
</template>

<style scoped>
#structure-view .entry-view {
	overflow-x: auto;
	overflow-y: auto;
	width: auto;
	max-width: 100%;
	height: auto;
	margin: 0 auto;
}
.entry-view {
	/* position: relative; */
	margin: 0;
}
.ellipsis {
	position: relative;
	padding: 0;
}

.ellipsis span {
	position: absolute;
	left: 0;
	right: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.scrollable {
	overflow-y: auto;
	overflow-x: hidden;
	height: 50vh;
}

#callScreen {
	width: 500px;
	height: 500px;
}

/* Let's get this party started */
::-webkit-scrollbar {
	height: 2px;
	background-color: rgba(65, 109, 116, 1);
	width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
	-webkit-border-radius: 10px;
	border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
	-webkit-border-radius: 10px;
	border-radius: 10px;
	background: grey;
}
.booth-name {
	color: white;
	font-size: 20px;
	margin-top: 15px;
	margin-left: 40px;
	margin-right: 20px;
}
.card-height {
	height: 600px;
}
.main-large {
	width: 100%;
}
.v-dialog--custom {
	width: 800px;
	height: 510px;
}
.iframe-size {
	height: 450px;
}
.bg-img {
	width: auto;
	min-width: 100%;
	right: 0;
	bottom: 0;
}
.scroll {
	overflow-y: auto;
}
.scroll-x {
	overflow-x: auto;
}
ul#feature {
	background: #416d74;
	padding: 10px;
}
ul#feature li a {
	margin: 0px;
	padding: 5px;
	color: white;
}
ul#detail-nav {
	list-style-type: none;
	margin: 0;
	padding: 0;
	overflow: hidden;
	background-color: #416d74;
}
ul#detail-nav li {
	float: left;
}
ul#detail-nav li a {
	display: block;
	color: white;
	text-align: center;
	padding: 12px 14px;
	text-decoration: none;
}
.active {
	border: 1px solid orange;
	border: 0.5px solid orange;
	background-color: orange;
}
.title-line {
	border: 0.5px solid white;
	background-color: white;
}
.box {
	display: flex;
}
.second-item {
	flex: 1 1 0;
}
.first-item {
	flex: 0 1 auto;
}
li a:hover {
	background-color: var(--li-a-background--hover);
}
li {
	display: block;
	background-color: var(--li-background);
}
.lyt-imgs-cog {
	border: 0px solid;
}
.body-container {
	width: auto;
	max-width: 100%;
	height: auto;
	position: relative;
}
img {
	/* vertical-align: middle; */
	text-align: center;
}
.horizontal-line {
	margin-top: 10px;
}
.back-to-floor {
	margin: 10px 0px 0px 10px;
	padding: 0px 0px 0px 0px;
	height: 30px;
	position: absolute;
	z-index: 6;
}
.imgMobile {
	width: 50px;
	top: -30px;
	position: absolute;
}
.spanMobile {
	bottom: -35px;
	position: absolute;
}
</style>

<script>
import axios from "axios";
import configuration from "../../configuration";
import { CometChat } from "@cometchat-pro/chat";

export default {
	/* eslint-disable no-mixed-spaces-and-tabs */
	props: ["tenantSlug", "experienceSlug", "boothId"],
	components: {},
	data: () => ({
		drawer: false,
		dialog: false,
		param: null,
		cols: "9",
		active: "Description",
		iconActive: "mdi-information",
		searchResult: [],
		currentIndex: 0,
		showDocument: false,
		showBannerPopup: false,
		haveAccess: false,
		baseLocation: axios.defaults.baseURL,
		boothList: [],
		productList: [],
		products: [],
		loading: false,
		items: [],
		search: null,
		entity: {
			bannerList: [],
			boothFeatureList: [],
			dataMap: {}
		},
		selectedbanner: [{ coordinateList: [] }],
		documents: [],
		document: {},
		videos: [],
		selectedDocument: {},
		selectedId: null,
		viewer: null,
		searchParam: "",
		boothRepList: [],
		backgroundImage: null,
		snackbar: false,
		snackbarContent: null,
		boothRep: {},
		iframeBanner: false,
		iframeDoc: false,
		boothImage: null,
		experienceUserList: [],
		indexRender: 1,
		topPosBtnBackToFloor: 36,
		tmpTopPosBtnBackToFloor: 36,
		widthMenu: 0,

		// Chat Box START

		noChatBooth: false,
		pageChange: false,
		goToChat: true,
		totalBoothVisitor: 0,
		onlineBoothVisitor: 0,
		chatBox: {
			entered: false,
			messageBuilder: null,
			chatMessage: null,
			chatMessageRules: [(v) => (!!v && /.*[^ ].*/.test(v)) || "Please enter your message"],
			chatUser: {
				role: "",
				uid: ""
			},
			validMessage: false,
			noMore: true,
			loading: false,
			messageList: [], // active conversation message list
			visitorList: [], // online user list
			limit: 50, // max is 50
			groupId: null,
			busId: null,
			conversation: {}, // active conversation
			conversationList: [], // conversation list on left pane
			chatNotificationSound: false,
			showBoothRepsOnly: false // show only boothreps (for others), boothreps still show all users online
		},
		// Chat Box END

		//mobile version START

		chatTab: null,
		chatCategories: [
			{ tab: "Conversation", content: "1", isBadgeOn: false },
			{ tab: "Chat", content: "2", isBadgeOn: false },
			{ tab: "Users Online", content: "3", isBadgeOn: false }
		],
		isMobile: false,
		showMobileConversation: true,
		showMobileChat: false,
		showMobileUserOnline: false,

		// mobile version END

		// audio-video call START

		call: {
			sessionId: "",
			receiverId: null,
			caller: null,
			receiver: null,
			callingProgress: false,
			incomingCall: false,
			ongoingCall: false
		},

		// audio-video call END

		color: {
			backgroundColor: "#416D74FF",
			bottomBackgroundColor: "#FFFFFFFF",
			fontColor: "#FFFFFFFF",
			buttonBackgroundColor: "#3B5A5FFF",
			buttonFontColor: "#FFFFFFFF",
			tabHoverColor: "#416D74FF",
			buttonBackgroundColor2: "#FF9800FF",
			buttonFontColor2: "#FFFFFFFF",
		}
	}),
	computed: {
		styleObject() {
			return {
				'--li-a-background--hover': this.color.tabHoverColor,
				'--li-background': this.color.backgroundColor,
				'--color': 'red',
			};
		},
	},
	created() {
		this.chatBox.groupId = this.$store.state.principal.experienceId + "-b-" + this.$route.params.boothId;
		this.chatBox.busId = this.$store.state.principal.experienceId + "-bus";
	},
	async mounted() {
		window.onscroll = () => {
			this.topPosBtnBackToFloor = this.tmpTopPosBtnBackToFloor - window.scrollY;
			this.scrollCheck();
		};
		this.getExperienceUser();
		this.getExperience();
		this.param = this.$route.params.boothId;
		await this.showLargeBooth(this.param);
		this.onResize();
		this.getColor();
		window.addEventListener("resize", this.onResize, { passive: true });
		this.noChatBooth = this.entity.dataMap.noChatBooth ? true : false;
		if (this.$root.showLiveSupport) {
			this.$root.setCurrentUrlLiveSupport(this.$router.currentRoute.path);
		}
		window.onresize = () => {
			this.setBtnBackToFloor();
		};
	},
	beforeDestroy: function () {
		this.cometExit();
	},
	watch: {
		search(val) {
			val && val !== this.selectedId && this.querySelections(val);
		},
		"$route.params.boothId"(newId) {
			this.showLargeBooth(newId);
		}
	},
	updated: function () {
		if (this.boothImage && this.indexRender == 8) {
			this.setCenterView("update");
		}

		var menu = document.getElementById("menu");
		if (menu && this.indexRender == 8) {
			this.tmpTopPosBtnBackToFloor = this.tmpTopPosBtnBackToFloor + menu.clientHeight;
			this.topPosBtnBackToFloor = this.tmpTopPosBtnBackToFloor;
			this.widthMenu = this.$refs.background.clientWidth;
		}

		if (this.indexRender <= 8) {
			this.indexRender = this.indexRender + 1;
		}
	},
	methods: {
		setBtnBackToFloor() {
			var menu = document.getElementById("menu");
			if (menu.clientWidth != this.widthMenu) {
				if (menu.clientWidth < 600) {
					this.tmpTopPosBtnBackToFloor = 36;
					this.widthMenu = 599;
				} else if (menu.clientWidth >= 600) {
					this.tmpTopPosBtnBackToFloor = 36 + menu.clientHeight;
					this.widthMenu= 959;
				} else {
					this.widthMenu = 960;
				}
				this.topPosBtnBackToFloor = this.tmpTopPosBtnBackToFloor - window.scrollY;
			}
		},
		setCenterView() {
			let mainDisplay = document.getElementById("main-display");
			mainDisplay.scrollLeft = (this.$refs.background.clientWidth - mainDisplay.clientWidth) / 2;
		},
		getExperienceUser() {
			axios
				.get("/system/user")
				.then(response => {
					this.chatBox.chatNotificationSound = response.data.chatNotificationSound ? response.data.chatNotificationSound : false;
				})
				.catch(() => {});
		},
		getExperience() {
			axios
				.get("/system/experience/find")
				.then(response => {
					this.chatBox.showBoothRepsOnly = response.data.dataMap.showBoothRepsOnly !== undefined && response.data.dataMap.showBoothRepsOnly ? response.data.dataMap.showBoothRepsOnly : false;
				})
				.catch(() => {});
		},
		navigateStructure() {
			if (this.entity.dataMap.floor) {
				this.$router.push(
					"/" + this.$route.params.tenantSlug + "/" + this.$route.params.experienceSlug + "/hall/" + this.entity.dataMap.floor
				);
			}
		},
		closeDoc() {
			this.showDocument = false;
			this.iframeDoc = false;
		},
		async checkRole(experienceUserId, boothId) {
			this.haveAccess = false;
			this.boothRep = {};
			await axios.get("/system/booth/boothRep/check/role?boothId=" + boothId + "&experienceUserId=" + experienceUserId).then((response) => {
				this.entity = response.data;
				// Check if large asset is exist and use it
				let vm = this
				this.$root.isImageExist(this.$root.largeAsset(this.entity.boothBackgroundImage), function(status) {
					if (status) {
						vm.entity.boothBackgroundImage = vm.$root.largeAsset(vm.entity.boothBackgroundImage);
					}
				});
				if (this.entity.bannerList.length > 0) {
					var video = document.getElementById("video");
					if (video != null) {
						video.load();
					}
				}
				if (this.entity.boothBackgroundImage) {
					this.entity.boothBackgroundImage = this.entity.boothBackgroundImage.replace(/\\/g, "/");
				}
				if (this.entity.isBoothRep) {
					this.viewer = "Booth_Rep";
					this.haveAccess = true;
					let featureBoothRep = {
						status: true,
						tabTitle: "Booth Stats",
						icon: "mdi-information"
					};
					this.entity.boothFeatureList.push(featureBoothRep);
					this.listBoothVisitor(this.entity.id);
				} else {
					this.visitExhibitorBooth(this.entity.id);
					this.haveAccess = true;
					this.viewer = "Experience_User";
				}
				if (!this.entity.description || this.entity.description == "" || this.entity.description == null) {
					this.entity.boothFeatureList[0].status = false;
				}
				this.documents = this.entity.documentList;
				if (this.documents.length < 1) {
					this.entity.boothFeatureList[1].status = false;
				}
				this.videos = this.entity.videoList;
				if (this.videos.length < 1) {
					this.entity.boothFeatureList[2].status = false;
				}
				if (this.entity.menuLinkList.length < 1) {
					this.entity.boothFeatureList[3].status = false;
				}
				this.boothRepList = this.entity.boothRepList;
				if (this.boothRepList.length < 1) {
					this.entity.boothFeatureList[4].status = false;
				}
				this.productList = this.entity.productList;
				if (this.productList.length < 1) {
					this.entity.boothFeatureList[5].status = false;
				}
				this.products = this.entity.productList;
				this.setDefaultActiveTab();
				if (this.entity.layoutId != null) {
					this.getLayout(this.entity.layoutId);
				}
				if (this.entity.transitMap.isUseCometChat)  {
					this.cometEnter();
				}
			});
		},
		getLayout(layoutId) {
			axios.get("/system/booth/layout?id=" + layoutId).then((response) => {
				let layout = [];
				layout = response.data.bannerList;
				this.boothImage = response.data.dataMap.value;
				// Check if large asset is exist and use it
				let vm = this
				this.$root.isImageExist(this.$root.largeAsset(this.boothImage), function(status) {
					if (status) {
						vm.boothImage = vm.$root.largeAsset(vm.boothImage);
					}
				});
				for (let i = 0; i < layout.length; i++) {
					this.entity.bannerList[i].coordinateList = layout[i].coordinateList;
					this.entity.bannerList[i].skewX = layout[i].skewX;
					this.entity.bannerList[i].skewY = layout[i].skewY;
				}
			});
		},
		setDefaultActiveTab() {
			let activeBoothFeature = [];
			activeBoothFeature = this.entity.boothFeatureList.filter((feature) => feature.status);
			if (activeBoothFeature.length > 0) {
				this.active = activeBoothFeature[0].tabTitle;
			}
		},
		listBoothVisitor(boothId) {
			axios.get("/system/booth/boothStat/listBoothVisitor?boothId=" + boothId).then((response) => {
				this.totalBoothVisitor = response.data;
			});
		},
		/*Write to activityLog*/
		visitExhibitorBooth(boothId) {
			let activityLog = {
				dataMap: { boothId: boothId },
				type: "Visit_an_exhibitor_booth"
			};
			this.$root.saveActivityLog(activityLog);
		},
		visitBoothBanner(banner) {
			let activityLog = {
				dataMap: { boothId: this.entity.id, sequence: banner.sequence },
				type: "Visit_booth_banner"
			};
			this.$root.saveActivityLog(activityLog);
		},
		viewDocument(id) {
			let activityLog = {
				dataMap: { boothId: this.entity.id, documentId: id },
				type: "View_Download_booth_document"
			};
			this.$root.saveActivityLog(activityLog);
		},
		watchVideo(id) {
			let activityLog = {
				dataMap: { boothId: this.entity.id, documentId: id },
				type: "Watch_booth_video"
			};
			this.$root.saveActivityLog(activityLog);
		},
		visitLink(menuLink) {
			let activityLog = {
				dataMap: { boothId: this.entity.id, index: menuLink.index },
				type: "Visit_booth_link_in_link_bar"
			};
			this.$root.saveActivityLog(activityLog);
		},
		clearSearch() {
			this.searchParam = "";
			this.productList = this.products;
		},
		querySelections(v) {
			this.loading = true;
			setTimeout(() => {
				if (v.length <= 1) {
					this.items = [];
				} else {
					axios.post("/system/booth/search", { keyword: v, experienceId: this.$store.state.principal.experienceId }).then((response) => {
						this.items = response.data;
					});
				}
				this.loading = false;
			}, 500);
		},
		setActive(menu) {
			this.active = menu.tabTitle;
			this.iconActive = menu.icon;
			this.dialog = false;
		},
		addBriefcase(doc) {
			axios
				.post("/system/document/briefcase/add", {
					experienceUserId: this.$store.state.principal.id,
					documentId: doc.id
				})
				.then((response) => {
					let status = response.data;
					this.snackbar = true;
					this.snackbarContent = status;
					if (status == "Saved") {
						let activityLog = {
							dataMap: { boothId: doc.boothId, documentId: doc.id },
							type: "Add_to_my_documents"
						};
						this.$root.saveActivityLog(activityLog);
					}
				});
		},
		showBanner(item) {
			this.currentIndex = this.entity.bannerList.indexOf(item);
			this.showBannerPopup = true;
			this.iframeBanner = true;
			if (
				this.entity.bannerList[this.currentIndex].url &&
				(this.entity.bannerList[this.currentIndex].url.includes("youtu") || this.entity.bannerList[this.currentIndex].url.includes("vimeo"))
			) {
				this.entity.bannerList[this.currentIndex].url = this.getUrlEmbed(this.entity.bannerList[this.currentIndex].url);
				console.log("url : " + this.entity.bannerList[this.currentIndex].url);
			}

			this.visitBoothBanner(item);
		},
		showSelectedBooth() {
			if (this.selectedId != null && this.viewer != "Booth_Rep") {
				this.toBooth(this.selectedId, 'next');
			}
		},
		toBooth(boothId, direction) {
			direction = direction == 'prev' ? 'previous' : direction;
			this.$router.push("/" + this.$route.params.tenantSlug + "/" + this.$route.params.experienceSlug + "/passthrough/booth/" + direction + "/" + boothId);
		},
		navigate(direction) {
			axios
				.post("/system/booth/navigate", {
					sortOrder: this.entity.sortOrder,
					direction: direction
				})
				.then(async (response) => {
					let boothId = response.data;
					this.toBooth(boothId, direction);
				});
		},
		openDocuments(document, type) {
			this.selectedDocument = null;
			this.showDocument = true;
			this.iframeDoc = true;
			if (type == "document") {
				this.viewDocument(document.id);
			} else {
				this.watchVideo(document.id);
			}
			this.findInDocument(document.id);
		},
		async showLargeBooth(id) {
			this.active = "Description";
			await this.checkRole(this.$store.state.principal.id, id);
		},
		findInDocument(id) {
			axios.get("/system/booth/document?id=" + id).then((response) => {
				this.selectedDocument = response.data;
				if (this.selectedDocument.value && this.selectedDocument.type == "Video") {
					if (this.selectedDocument.value.includes("youtu") || this.selectedDocument.value.includes("vimeo")) {
						this.selectedDocument.value = this.getUrlEmbed(this.selectedDocument.value);
					}
					console.log("url : " + this.selectedDocument.value);
				}
			});
		},
		getUrlEmbed(url) {
			if (url.includes("youtu")) {
				let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
				let match = url.match(regExp);
				let urlEmbed = "https://www.youtube.com/embed/" + match[2] + "?autoplay=1&showinfo=0&controls=1";
				return urlEmbed;
			} else if (url.includes("vimeo")) {
				if (!url.includes("https://player.vimeo.com/video/")) {
					let regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
					let match = url.match(regExp);
					let urlEmbed = "https://player.vimeo.com/video/" + match[5] + "?autoplay=1&showinfo=0&controls=1";
					return urlEmbed;
				} else {
					return url;
				}
			}
		},
		searchProduct() {
			if (this.searchParam != "") {
				axios.get("/system/booth/product/search?boothId=" + this.entity.id + "&keyword=" + this.searchParam).then((response) => {
					this.productList = response.data;
				});
			} else {
				this.productList = this.products;
			}
		},

		// Chat Box START

		async cometEnter() {
			let groupId = this.chatBox.groupId;
			let busId = this.chatBox.busId;

			this.chatBox.entered = true;

			this.chatBox.chatUser = await CometChat.getLoggedinUser();

			let found = false;
			let busFound = false;

			let groupBuilder = new CometChat.GroupsRequestBuilder()
				.joinedOnly(true)
				.setSearchKeyword(this.$store.state.principal.experienceId + "-")
				.setLimit(100)
				.build();

			let groupList = [];
			do {
				groupList = await groupBuilder.fetchNext();
				for (let i of groupList) {
					if (i.guid == groupId) {
						found = true;
					} else if (i.guid == busId) {
						busFound = true;
					}
				}
			} while (groupList && groupList.length == 100);

			// join group
			if (!found) {
				await CometChat.joinGroup(groupId, "public", "");
			}
			if (!busFound) {
				await CometChat.joinGroup(busId, "public", "");
			}

			// change role
			this.chatBox.chatUser.role = groupId;
			this.chatBox.chatUser = await CometChat.updateUser(this.chatBox.chatUser, configuration.apiKeyCometChat);

			// notify in bus that just entered group
			await CometChat.sendMessage(
				new CometChat.TextMessage(busId, JSON.stringify({ type: "Enter group", groupId: groupId }), CometChat.RECEIVER_TYPE.GROUP)
			);

			// right pane
			this.listVisitorInitial();

			// center pane
			this.chatBox.conversation.type = "group";
			this.chatBox.conversation.id = this.chatBox.groupId;
			this.chatBox.conversation.name = this.entity.name;
			this.listMessageInitial();

			// left pane
			let lastMessage = await this.getGroupConversationInitial(this.chatBox.groupId);
			this.chatBox.conversationList.push({
				type: "group",
				id: this.chatBox.groupId,
				name: this.entity.name,
				unreadCount: 0,
				lastMessage: lastMessage
			});
			this.listDirectInitial();

			CometChat.addMessageListener(
				"messageListener-" + groupId,
				new CometChat.MessageListener({
					onTextMessageReceived: (textMessage) => {
						if (
							(textMessage.receiverType == "group" &&
								this.chatBox.conversation.type == "group" &&
								textMessage.receiverId == this.chatBox.conversation.id) || //
							(textMessage.receiverType == "user" &&
								this.chatBox.conversation.type == "user" &&
								textMessage.sender.uid == this.chatBox.conversation.id) //
						) {
							this.chatBox.messageList.push(this.minimizeMessage(textMessage));
							this.conversationLastMessage(this.chatBox.conversation.type, this.chatBox.conversation.id, textMessage);

							if (this.chatBox.chatNotificationSound) {
								this.notificationSound();
							}
							this.$nextTick(() => {
								this.scrollToBottom();
							});
						} else if (textMessage.receiverId == busId) {
							let data = JSON.parse(textMessage.data.text);
							if (data.type == "Enter group" && data.groupId == groupId) {
								let uid = textMessage.sender.uid;
								let found = false;
								for (let visitor of this.chatBox.visitorList) {
									if (visitor.uid == uid) {
										found = true;
										break;
									}
								}
								if (!found) {
									if (this.chatBox.showBoothRepsOnly && !this.entity.isBoothRep) {
										// if showBoothRepsOnly switch is active and the user is not a booth rep, then only fill users online with its boothreps
										for (let j of this.entity.boothRepList) {
											if (uid === j.chatId) {
												this.chatBox.visitorList.push({
													uid: textMessage.sender.uid,
													name: textMessage.sender.name
												});
												this.onlineBoothVisitor++;
											}
										}
									} else {
										this.chatBox.visitorList.push({
											uid: textMessage.sender.uid,
											name: textMessage.sender.name
										});
										this.onlineBoothVisitor++;
									}
								}
							} else if ((data.type == "Exit group" && data.groupId == groupId) || data.type == "Logout") {
								let uid = textMessage.sender.uid;
								for (let i in this.chatBox.visitorList) {
									let visitor = this.chatBox.visitorList[i];
									if (visitor.uid == uid) {
										this.chatBox.visitorList.splice(i, 1);
										this.onlineBoothVisitor--;
										break;
									}
								}
							}
						} else if (textMessage.receiverType == "group" && textMessage.receiver.guid == groupId) {
							this.conversationLastMessage("group", groupId, textMessage);
							this.conversationUnreadIncrement("group", groupId);
							if (this.chatBox.chatNotificationSound) {
								this.notificationSound();
							}
						} else if (textMessage.receiverType == "user") {
							this.conversationCreateIfNotExist("user", textMessage.sender.uid, textMessage.sender.name, textMessage);
							this.conversationLastMessage("user", textMessage.sender.uid, textMessage);
							this.conversationUnreadIncrement("user", textMessage.sender.uid);
							if (this.chatBox.chatNotificationSound) {
								this.notificationSound();
							}
						}
					}
				})
			);

			// audio-video call START

			let globalContext = this;

			CometChat.addCallListener(
				"callListener-" + groupId,
				new CometChat.CallListener({
					onIncomingCallReceived(call) {
						if (call.callInitiator.uid != globalContext.chatBox.chatUser.uid && !globalContext.call.ongoingCall //
							&& (globalContext.groupId == call.receiverId || call.receiverType == 'user')) {
							globalContext.call.caller = call.callInitiator;
							globalContext.call.receiver = call.callReceiver;
							globalContext.call.incomingCall = true;
							globalContext.call.sessionId = call.sessionId;
						}
					},
					onOutgoingCallAccepted(call) {
						globalContext.setOnCallAccepted().then(() => {
							let sessionId = call.sessionId;
							let callType = call.type;
							let callSettings = new CometChat.CallSettingsBuilder()
								.setSessionID(sessionId)
								.enableDefaultLayout(true)
								.setIsAudioOnlyCall(callType == "audio" ? true : false)
								.showScreenShareButton(false)
								.build();

							CometChat.startCall(
								callSettings,
								document.getElementById("callScreen"),
								new CometChat.OngoingCallListener({
									onUserJoined: (user) => {
										/* Notification received here if another user joins the call. */
										console.log("User joined call:", user);
									},
									onUserLeft: (user) => {
										/* Notification received here if another user left the call. */
										console.log("User left call:", user);
									},
									onCallEnded: (call) => {
										/* Notification received here if current ongoing call is ended. */
										console.log("Call ended :", call);
										globalContext.call.ongoingCall = false;
										globalContext.call.incomingCall = false;
										globalContext.call.callingProgress = false;
										globalContext.call.receiverId = null;
										globalContext.call.sessionId = "";
									},
									onError: (error) => {
										console.log("Call error :", error);
										globalContext.call.ongoingCall = false;
										globalContext.call.incomingCall = false;
										globalContext.call.callingProgress = false;
										globalContext.call.receiverId = null;
										globalContext.call.sessionId = "";
									}
								})
							);
						});
					},
					onOutgoingCallRejected(call) {
						console.log("Outgoing call rejected :", call);
						globalContext.call.incomingCall = false;
						globalContext.call.ongoingCall = false;
						globalContext.call.callingProgress = false;
						globalContext.call.receiverId = null;
						globalContext.call.sessionId = "";
					},
					onIncomingCallCancelled(call) {
						console.log("Incoming call cancelled :", call);
						globalContext.call.incomingCall = false;
						globalContext.call.ongoingCall = false;
						globalContext.call.callingProgress = false;
						globalContext.call.receiverId = null;
						globalContext.call.sessionId = "";
					}
				})
			);

			// audio-video call END
		},
		async cometExit() {
			let groupId = this.chatBox.groupId;
			let busId = this.chatBox.busId;

			document.title = "V-Unite";

			if (this.chatBox.entered) {
				CometChat.removeMessageListener("messageListener-" + groupId);
				CometChat.removeCallListener("callListener-" + groupId);

				if (this.$store.state.principal.token) {
					this.chatBox.chatUser.role = "default";
					await CometChat.updateUser(this.chatBox.chatUser, configuration.apiKeyCometChat);

					await CometChat.sendMessage(
						new CometChat.TextMessage(busId, JSON.stringify({ type: "Exit group", groupId: groupId }), CometChat.RECEIVER_TYPE.GROUP)
					);
				}
			}
		},
		async listVisitorInitial() {
			let groupId = this.chatBox.groupId;
			let memberList;
			let list = [];
			let limit = this.chatBox.limit;
			let builder = new CometChat.UsersRequestBuilder().setLimit(limit).setStatus(CometChat.USER_STATUS.ONLINE).setRole(groupId).build();

			do {
				memberList = await builder.fetchNext();
				for (let i of memberList) {
					if (this.chatBox.showBoothRepsOnly && !this.entity.isBoothRep) {
						// if showBoothRepsOnly switch is active and the user is NOT a booth rep, then only fill users online with its boothreps
						for (let j of this.entity.boothRepList) {
							if (i.uid === j.chatId) {
								list.push(this.minimizeVisitor(i));
							}
						}
					} else {
						list.push(this.minimizeVisitor(i));
					}
				}
			} while (memberList && memberList.length == limit);

			this.chatBox.visitorList = list;
			this.onlineBoothVisitor = list.length;
		},
		async getGroupConversationInitial(guid) {
			let groupConversation = CometChat.getConversation(guid, "group").then(
				(conversation) => {
					return conversation.lastMessage;
				},
				(error) => {
					this.cometChatErrorNotif(error);
					return null;
				}
			);
			return groupConversation;
		},
		async listDirectInitial() {
			let conversationList;
			let list = [];
			let limit = this.chatBox.limit;
			let builder = new CometChat.ConversationsRequestBuilder().setLimit(limit).setConversationType("user").build();

			do {
				conversationList = await builder.fetchNext();
				for (let i of conversationList) {
					list.push(this.minimizeConversation(i));
					if (this.minimizeConversation(i).unreadCount > 0) {
						document.title = "You have new message(s)";
					}
				}
			} while (conversationList && conversationList.length == limit);

			this.chatBox.conversationList.push(...list);
		},
		listMessageInitial() {
			let limit = this.chatBox.limit;

			if (this.chatBox.conversation.type == "group") {
				this.chatBox.messageBuilder = new CometChat.MessagesRequestBuilder().setLimit(limit).setGUID(this.chatBox.conversation.id).build();
			} else {
				this.chatBox.messageBuilder = new CometChat.MessagesRequestBuilder().setLimit(limit).setUID(this.chatBox.conversation.id).build();
			}

			this.chatBox.noMore = false;
			this.chatBox.loading = true;

			this.chatBox.messageList.splice(0, this.chatBox.messageList.length);
			this.chatBox.messageBuilder
				.fetchPrevious()
				.then((messageList) => {
					if (messageList.length < limit) {
						this.chatBox.noMore = true;
					}
					let lastMessage;
					for (let m of messageList) {
						this.chatBox.messageList.push(this.minimizeMessage(m));
						lastMessage = m;
					}

					if (lastMessage) {
						CometChat.markAsRead(lastMessage.id, this.chatBox.conversation.id, this.chatBox.conversation.type, this.chatBox.chatUser.uid);
					}

					this.$nextTick(() => {
						this.scrollToBottom();
					});
				})
				.catch((error) => this.cometChatErrorNotif(error))
				.finally(() => {
					this.chatBox.loading = false;
				});
		},
		listMessageHistory() {
			let limit = this.chatBox.limit;

			this.chatBox.noMore = false;
			this.chatBox.loading = true;

			this.chatBox.messageBuilder
				.fetchPrevious()
				.then((messageList) => {
					if (messageList.length < limit) {
						this.chatBox.noMore = true;
					}
					for (let m of messageList.reverse()) {
						this.chatBox.messageList.unshift(this.minimizeMessage(m));
					}
				})
				.catch((error) => this.cometChatErrorNotif(error))
				.finally(() => {
					this.chatBox.loading = false;
				});
		},
		async sendMessage() {
			if (this.chatBox.chatMessage) {
				let message = new CometChat.TextMessage(
					this.chatBox.conversation.id,
					this.chatBox.chatMessage,
					this.chatBox.conversation.type == "group" ? CometChat.RECEIVER_TYPE.GROUP : CometChat.RECEIVER_TYPE.USER
				);

				message = await CometChat.sendMessage(message);

				if(this.chatBox.conversation.id.includes("-b-")){
					let activityLog = {
						type: "Chat_with_an_exhibitor_in_booth",
						dataMap: {
							groupChatId: this.chatBox.conversation.id,
							boothId: this.$route.params.boothId
							}
						};
					this.$root.saveActivityLog(activityLog);
					console.log("Activity set");
				}

				this.chatBox.messageList.push(this.minimizeMessage(message));
				this.chatBox.chatMessage = null;

				this.conversationCreateIfNotExist(this.chatBox.conversation.type, this.chatBox.conversation.id, message.receiver.name, message);
				this.conversationLastMessage(this.chatBox.conversation.type, this.chatBox.conversation.id, message);

				this.$nextTick(() => {
					this.scrollToBottom();
				});
			}
		},
		converse(type, id, name) {
			this.showMobileConversation = false;
			this.showMobileChat = true;
			this.showMobileUserOnline = false;

			if (!(this.chatBox.conversation.type == type && this.chatBox.conversation.id == id)) {
				this.chatBox.conversation.type = type;
				this.chatBox.conversation.id = id;
				this.chatBox.conversation.name = name;

				this.conversationUnreadToZero(type, id);
				this.listMessageInitial();
			}
		},
		conversationCreateIfNotExist(type, id, name, message) {
			for (let conversation of this.chatBox.conversationList) {
				if (conversation.type == type && conversation.id == id) {
					return;
				}
			}
			this.chatBox.conversationList.push({
				type: type,
				id: id,
				name: name,
				unreadCount: 0,
				lastMessage: message
			});
		},
		conversationUnreadToZero(type, id) {
			let anyUnreadMessages = false;

			for (let conversation of this.chatBox.conversationList) {
				if (conversation.type == type && conversation.id == id) {
					conversation.unreadCount = 0;
				}

				if (conversation.unreadCount > 0) {
					anyUnreadMessages = true;
				}
			}

			if (anyUnreadMessages) {
				document.title = "You have new message(s)";
			} else {
				document.title = "V-Unite";
			}
		},
		conversationUnreadIncrement(type, id) {
			for (let conversation of this.chatBox.conversationList) {
				if (conversation.type == type && conversation.id == id) {
					conversation.unreadCount++;
					document.title = "You have new message(s)";
				}
			}
		},
		conversationLastMessage(type, id, message) {
			for (let conversation of this.chatBox.conversationList) {
				if (conversation.type == type && conversation.id == id) {
					conversation.lastMessage = message;
				}
			}
		},
		content(message) {
			if (message) {
				if (message.category == "action") {
					return message.message;
				} else if (message.category == "call") {
					return message.type.charAt(0).toUpperCase() + message.type.slice(1) + " call " + message.action;
				}
			}
			return message.text;
		},
		minimizeMessage(message) {
			return {
				id: message.id,
				category: message.category,
				sender: {
					uid: message.sender.uid,
					name: message.sender.name
				},
				sentAt: message.sentAt,
				// category: message
				text: message.text,
				// category: action
				message: message.message,
				// category: call
				action: message.action,
				type: message.type
			};
		},
		minimizeVisitor(visitor) {
			return { uid: visitor.uid, name: visitor.name };
		},
		minimizeConversation(conversation) {
			return {
				type: conversation.conversationType,
				id: conversation.conversationWith.uid,
				name: conversation.conversationWith.name,
				unreadCount: conversation.unreadMessageCount,
				lastMessage: conversation.lastMessage
			};
		},
		async boothChange() {
			this.pageChange = true; // to hold previous-next button while cometchat loading

			// clean up current booth chat, reload it with the new one
			await this.cometExit();
			this.chatBox.groupId = this.$store.state.principal.experienceId + "-b-" + this.$route.params.boothId;
			this.chatBox.busId = this.$store.state.principal.experienceId + "-bus";
			this.chatBox.messageList = [];
			this.chatBox.visitorList = [];
			this.chatBox.conversation = {};
			this.chatBox.conversationList = [];
			this.$refs.messageForm.reset();
			await this.cometEnter();

			this.pageChange = false; // release hold for previous-next button
		},
		soundSwitch() {
			axios
				.post("/system/user/edit/sound", {
					chatNotificationSound: this.chatBox.chatNotificationSound
				})
				.then(() => {})
				.catch(() => {});
		},
		notificationSound() {
			let snd = new Audio(require("./../../assets/Chatbox/notification.ogg"));
			snd.play();
		},
		formatDate(value) {
			let date = new Date(value * 1000);
			let options = {
				year: "numeric",
				month: "long",
				day: "numeric",
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit"
			};
			return date.toLocaleString("en-US", options);
		},
		scrollToMessage(msgId) {
			let chat = document.getElementById("chatBox");
			if (chat != null) {
				let msg = document.getElementById("msg-" + msgId);
				msg.scrollIntoView();
			}
		},
		scrollToBottom() {
			let chat = document.getElementById("chatBox");
			if (chat != null) {
				chat.scrollTo(0, chat.scrollHeight + 30);
			}
		},
		scrollToChat() {
			let card = document.getElementById("chatCard");
			card.scrollIntoView({ behavior: "smooth" });
		},
		scrollToTopPage() {
			document.body.scrollTo({ top: 0, behavior: "smooth" });
			document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
		},
		scrollCheck() {
			let modifier = this.isMobile ? 0.3 : 0.4;
			if (
				document.body.scrollTop > modifier * document.body.scrollHeight ||
				document.documentElement.scrollTop > modifier * document.documentElement.scrollHeight
			) {
				this.goToChat = false;
			} else {
				this.goToChat = true;
			}
		},
		cometChatErrorNotif(error) {
			let notification = {
				title: "CometChat error",
				content: {
					errorList: [error.message],
					fieldErrorList: [],
					noticeList: [],
					type: "NOTIFICATION"
				}
			};
			this.$store.commit("showNotification", notification);
		},

		// Chat Box END

		// mobile version START
		onResize() {
			this.isMobile = window.matchMedia("only screen and (max-width: 599px)").matches;
		},
		goToSelectedTab(content) {
			this.showMobileConversation = content == 1 ? true : false;
			this.showMobileChat = content == 2 ? true : false;
			this.showMobileUserOnline = content == 3 ? true : false;
		},

		// mobile version END

		// audio-video call START

		async startCall(id, type, receiver) {
			this.call.callingProgress = true;
			let globalContext = this;

			let receiverID = id;
			let callType = type == "video" ? CometChat.CALL_TYPE.VIDEO : CometChat.CALL_TYPE.AUDIO;
			let receiverType = receiver == "user" ? CometChat.RECEIVER_TYPE.USER : CometChat.RECEIVER_TYPE.GROUP;

			let call = new CometChat.Call(receiverID, callType, receiverType);

			CometChat.initiateCall(call).then(
				(outGoingCall) => {
					globalContext.call.caller = outGoingCall.callInitiator;
					globalContext.call.receiver = outGoingCall.callReceiver;
					globalContext.call.sessionId = outGoingCall.sessionId;
				},
				(error) => {
					this.cometChatErrorNotif(error);
				}
			);
		},
		async acceptCall() {
			let globalContext = this;

			this.setOnCallAccepted().then(() => {
				globalContext.call.incomingCall = false;

				let sessionID = globalContext.call.sessionId;

				CometChat.acceptCall(sessionID).then(
					(call) => {
						console.log("Call accepted successfully:", call);

						let sessionId = call.sessionId;
						let callType = call.type;
						let callSettings = new CometChat.CallSettingsBuilder()
							.setSessionID(sessionId)
							.enableDefaultLayout(true)
							.setIsAudioOnlyCall(callType == "audio" ? true : false)
							.showScreenShareButton(false)
							.build();

						CometChat.startCall(
							callSettings,
							document.getElementById("callScreen"),
							new CometChat.OngoingCallListener({
								onUserJoined: (user) => {
									/* Notification received here if another user joins the call. */
									console.log("User joined call:", user);
								},
								onUserLeft: (user) => {
									/* Notification received here if another user left the call. */
									console.log("User left call:", user);
								},
								onCallEnded: (call) => {
									/* Notification received here if current ongoing call is ended. */
									console.log("Call ended:", call);
									globalContext.call.ongoingCall = false;
									globalContext.call.incomingCall = false;
									globalContext.call.callingProgress = false;
									globalContext.call.receiverId = null;
									globalContext.call.sessionId = "";
								},
								onError: (error) => {
									console.log("Call error :", error);
									globalContext.call.ongoingCall = false;
									globalContext.call.incomingCall = false;
									globalContext.call.callingProgress = false;
									globalContext.call.receiverId = null;
									globalContext.call.sessionId = "";
								}
							})
						);
					},
					(error) => {
						console.log("Call acceptance failed with error", error);
						this.cometChatErrorNotif(error);
					}
				);
			});
		},
		async rejectCall(type) {
			let sessionID = this.call.sessionId;
			let globalContext = this;
			let status = type == "reject" ? CometChat.CALL_STATUS.REJECTED : CometChat.CALL_STATUS.CANCELLED;

			await CometChat.rejectCall(sessionID, status).then(
				(call) => {
					console.log("Call rejected successfully", call);
					globalContext.call.incomingCall = false;
					globalContext.call.ongoingCall = false;
					globalContext.call.callingProgress = false;
					globalContext.call.receiverId = null;
					globalContext.call.sessionId = "";
				},
				(error) => {
					console.log("Call rejection failed with error:", error);
					globalContext.call.incomingCall = false;
					globalContext.call.ongoingCall = false;
					globalContext.call.callingProgress = false;
					globalContext.call.receiverId = null;
					globalContext.call.sessionId = "";

					this.cometChatErrorNotif(error);
				}
			);
		},
		async callUser(id, type, receiver) {
			this.call.receiverId = id;
			await this.startCall(this.call.receiverId, type, receiver);
		},
		async setOnCallAccepted() {
			let globalContext = this;
			return new Promise(function (resolve, reject) {
				globalContext.call.ongoingCall = true;
				resolve();
				console.log(reject);
			});
		},

		// audio-video call END

		getColor() {
			axios
				.post("/system/experienceColors/find",{
					tenantSlug: this.tenantSlug,
					experienceSlug: this.experienceSlug,
					page: "Booth"
				})
				.then(response => {
					if (response.data) {
						this.color = response.data;
					}
				})
				.catch(() => {});
		}
	}
};
/* eslint-enable no-mixed-spaces-and-tabs */
</script>